module.exports = __webpack_public_path__ + "img/transgender-alt.d82c58c4.svg";